<script>
/**
 * Abstract component that represents any box that only features
 * checkboxes for choosing certain options.
 * Handles setting initially selected options and updates 'selected' 
 * with list of new selected options.
 * 
 * Getting the options themselves from the API is handled by it's children.
 */
import Vue from "vue";

export default {
   data() {
      return {
         options: {}
      }
   },

   props: ['initialSelected', 'new', 'delete'],

   methods: {
      onCheck(target) {
         if (target.checked) {
            if ($.inArray(target.value, this.initialSelected) < 0) {
               //if it wasn't initally selected it is new and needs to be
               //added to the database
               this.new.push(target.value);
            } else { //it will have been unselected which it means it was added to delete
               var index = this.delete.indexOf(target.value);
               if (index > -1) {
                  this.delete.splice(index, 1);
               }
            }
         } else {
            if ($.inArray(target.value, this.initialSelected) >= 0) {
               //if it was initally selected, need to remove it
               this.delete.push(target.value);
            } else { //it will have been added to new so we need to remove it
               var index = this.new.indexOf(target.value);
               if (index > -1) {
                  this.new.splice(index, 1);
               }
            }
         }
      }
   },
}
</script>